import { CheckBox } from "devextreme-react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import React from "react";
import "./NewForms.css";

interface IProps {
  title?: string;
  fieldName: string;
  showBorder?: boolean;
}

export const NFCheckBoxInput = ({
  title,
  fieldName,
  showBorder = true,
}: IProps) => {
  const { register, control } = useFormContext();
  const { errors, dirtyFields } = useFormState();

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={{
        onChange: (newValue: string) => {
          // console.log(newValue);
        },
      }}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <>
          <div
            className={
              title ? "form-group d-flex h-100 align-items-center" : ""
            }
          >
            <CheckBox
              text={title}
              value={value}
              onValueChanged={(e) => onChange(e.value)}
            />
          </div>
        </>
      )}
    />
  );
};
